<template>
  <v-list-item :class="(containerNoMargin ? 'ma-0' : 'mb-4') + (containerNoPadding ? ' pa-0' : '')">
    <!-- prepend image / icon -->
    <v-list-item-avatar v-if="currentBreakpoint > 1 && (!isNoWs(prependImage) || !isNoWs(prependIcon))" class="ma-0 mr-4 row-height align-center">
      <v-img v-if="!isNoWs(prependImage)" :src="course.additionalDetails.CourseLeaderPortrait"></v-img>
      <v-icon v-else-if="!isNoWs(prependIcon)"> {{ prependIcon }} </v-icon>
    </v-list-item-avatar>

    <!-- content -->
    <slot name="content-override">
      <v-list-item-content :class="'align-center row-height' + (expandable ? ' overflow-visible pa-0' : ' elevation-2 pa-2 rounded')">
        <div v-if="!expandable" style="position: relative; max-width: 100%">
          <slot name="header">
            <v-list-item-title style="text-wrap: balance; "><div v-html="title" /></v-list-item-title>
            <v-list-item-subtitle style="text-wrap: balance;  white-space: pre-line"><div v-html="subTitle" /></v-list-item-subtitle>
          </slot>
        </div>

        <div v-else>
          <v-expansion-panels accordion :mandatory="expansionStayOpen">
            <v-expansion-panel class="pa-2">
              <!-- title -->
              <v-expansion-panel-header :expand-icon="expansionStayOpen ? '' : 'mdi-menu-down'" class="pa-0">
                <slot name="expansion-header">
                  {{ title }}
                </slot>
              </v-expansion-panel-header>

              <!-- expansion content -->
              <v-expansion-panel-content :style="'max-height: ' + expansionContentMaxHeight + '; overflow-y: auto; overflow-x: hidden'" class="pa-0">
                <v-list subheader>
                  <v-subheader v-if="!isNoWs(subTitle)" inset>{{ subTitle }}</v-subheader>

                  <slot name="expansion-content" />
                </v-list>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
      </v-list-item-content>
    </slot>

    <!-- action -->
    <v-list-item-action
      v-if="!isNoWs(appendIcon)"
      class="align-center row-height elevation-2 pa-2 ma-0 ml-4 rounded row-height">
      <slot name="actionarea">
        <v-tooltip top v-if="!isNoWs(appendIconTooltip)">
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-on="on" v-bind="attrs" icon @click="handleActionIconClick">
              <v-icon> {{ appendIcon }} </v-icon>
            </v-btn>
          </template>
          <span v-html="appendIconTooltip"></span>
        </v-tooltip>

        <v-btn v-else icon @click="handleActionIconClick">
          <v-icon> {{ appendIcon }} </v-icon>
        </v-btn>
      </slot>
    </v-list-item-action>
  </v-list-item>
</template>

<script>
import HelpersMixin from '@/mixins/helpers.js';
import ResponsiveMixin from '@/mixins/responsive.js';

export default {
  name: 'Detail',

  emits: ['onActionIconClick'],

  props: {
    /** icon that should be displayed on the left side of the element (only shows if prependImage is NoWs) */
    prependIcon: String,
    /** image that should be displayed on the left side of the element (instead of the prependIcon) */
    prependImage: String,
    /** icon that should be displayed on the right side of the element */
    appendIcon: String,
    title: String,
    subTitle: String,
    /**
     * whether the details should be expandable or not
     *
     * you have to use the template slot "expansion-content" in order to add content
     *
     * the parent element of the "expansion-content"-slot is a v-list
     */
    expandable: Boolean,
    /** overrides the max height of the content from a expansion detail */
    expansionContentMaxHeight: {
      type: String,
      default: '475px',
    },
    /** whether the expansion detail stay open or not */
    expansionStayOpen: {
      type: Boolean,
      default: false,
    },
    appendIconTooltip: String,
    /** whether the detail container should have padding or not */
    containerNoPadding: Boolean,
    /** whether the detail container should have margin or not */
    containerNoMargin: Boolean,
    /** whether the detail is standalone or not (not several under each other, removes the margin at the bottom).  */
    standalone: Boolean,
  },

  mixins: [HelpersMixin, ResponsiveMixin],

  methods: {
    handleActionIconClick() {
      this.$emit('onActionIconClick');
    },
  },
};
</script>

<style scoped>
.row-height {
  min-height: 64px;
}
</style>
